import { useEffect } from 'react';

export const useComponentDidMount = (func: VoidFunction) => useEffect(func, []);
